/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import React, { useEffect } from "react";
import Grid from "@mui/material/Grid";
import { Checkbox, Typography } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import { filterMediaObjectsByFieldname } from "@/src/services/mediaObjects";
import MultipleFileUpload from "@/src/components/Form/Common/FileUpload/MultipleFileUpload";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import { MediaObject } from "@/src/types/Entities/MediaObject/MediaObject";
import { useForm } from "@/src/provider/Form/FormProvider";
import { formValue } from "@/src/services/formServiceFunctions";

type RefinementDocumentProps = {
  requestedDocument: NonNullable<AbstractCase["aiRefinementDocuments"]>[number];
  product: AbstractCase;
  refreshMediaObjectCollection: () => void;
  mediaObjectCollection: Array<MediaObject>;
  index: number;
};

export default function RefinementDocument({
  requestedDocument,
  product,
  mediaObjectCollection,
  refreshMediaObjectCollection,
  index,
}: RefinementDocumentProps) {
  const { handleChange, values } = useForm();

  const isMissingPath = "aiRefinementDocuments[" + index + "].isMissing";

  const mediaObjectsForFieldName = filterMediaObjectsByFieldname(mediaObjectCollection, requestedDocument.fieldname);

  useEffect(() => {
    if (mediaObjectsForFieldName.length > 0 && formValue(values, isMissingPath) === true) {
      handleChange({
        target: {
          name: isMissingPath,
          checked: false,
          value: false,
          type: "checkbox",
        },
      });
    }
  }, [mediaObjectsForFieldName.length]);

  return (
    <Grid container>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <Typography variant={"body1"} component={"h3"} sx={{ marginBottom: "0.5rem" }}>
          <strong>{requestedDocument.documentName}</strong>
        </Typography>
        <FormControlLabel
          control={<Checkbox checked={formValue(values, isMissingPath)} name={isMissingPath} onChange={handleChange} disabled={mediaObjectsForFieldName.length > 0} />}
          label={
            <Typography variant={"body2"} component={"span"}>
              Dieses Dokument liegt mir leider nicht vor
            </Typography>
          }
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <MultipleFileUpload
          product={product}
          fieldname={requestedDocument.fieldname}
          description={requestedDocument.description}
          mediaObjectCollection={mediaObjectsForFieldName}
          fetchMediaObjects={refreshMediaObjectCollection}
        />
      </Grid>
    </Grid>
  );
}
